module.exports = __webpack_public_path__ + "static/p08_cerdoGrandeCabeza-9e13186e57a1b9b5e258e000be0d82e4.png";